import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { uniqueId } from "lodash";

import { Table } from "../../../../components/ui";
import usePagination from "../../../../hooks/usePagination";
import { complianceSearchActions } from "../../../../reducers/complianceSearch";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { TOP_LIVE_SIM_TAKERS } from "../../constants";
import { SectionTitle } from "../../styledComponents";

const TopLiveSimTakers: React.FC = () => {
  const dispatch = useDispatch();
  const pagination = usePagination();
  const { loading, data } = useSelector((state) => state.complianceSearch.topLiveSimTakers);

  const { isError, error } = useQuery({
    queryKey: [COMPLIANCE_API_URLS.getTopLiveSimTakers, pagination.limit, pagination.page],
    async queryFn({ signal }) {
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());

      dispatch(complianceSearchActions.fetchTopLiveSimTakersRequest());
      const response = await ComplianceAPI.getTopLiveSimTakersRequest(query.toString(), signal);
      dispatch(complianceSearchActions.fetchTopLiveSimTakersSuccess(response.data));
      pagination.setCount(response.data.results.count);
      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetching Top LiveSim Takers", error);
      dispatch(complianceSearchActions.fetchTopLiveSimTakersFailed());
    }
  }, [isError, error]);

  useEffect(() => {
    pagination.setPage(0);
  }, [pagination.limit]);

  return (
    <SectionTitle title="Top LiveSim Takers">
      <Table
        columns={TOP_LIVE_SIM_TAKERS}
        loading={loading}
        extractKey={(row) => `${row.id}_${uniqueId()}`}
        data={data.results.rows}
        pagination={pagination}
        csv_table_name={"Top Live losses, and top LiveSim takers - Top LiveSim takers"}
      />
    </SectionTitle>
  );
};

export default TopLiveSimTakers;
